class UserController extends AbstractEntityEditController
	@register()
	@inject '$filter',
		'$sce'
		'roles'
		'user'
		'shopsList'
		'ConfigurationService'
		'ShopRepository'
		'ToastService'
		'UserRepository'
		'UserService'
		'UserInformation'
		'BACKEND_USER_ENTITY_TYPE'
		'AuthenticationRepository'
		'CopyService'

	initialize: ->
		@mainCrud.entityType = 'general.user'
		@mainCrud.entityTitle = 'wbo.new.user'

		@currentUser = @UserInformation.getSubUser()
		@allowImageEdit = @ConfigurationService.getValue('Backoffice.Setting.Cdn.Url') == null
		@isLoginQrCodeGenerationEnabled = @ConfigurationService.isEnabled('Shared.Setting.LoginQRCodeGeneration.Enabled')
		@shops = []
		@disableRoles = false
		@hasPassword = false
		@types =
			users: @BACKEND_USER_ENTITY_TYPE.USER
			employees: @BACKEND_USER_ENTITY_TYPE.EMPLOYEE

		if angular.isDefined @user.id
			@hasPassword = @user.has_password
			@mainCrud.entityTitle = @user.full_name
			@mainCrud.isNewEntity = false

			if !_.isEmpty(@user.shops)

				shopsMap = _.indexBy(@shopsList, 'id')

				for shop in @user.shops
					shopId = shop.id ? shop
					shopData = shopsMap[shopId]

					if shopData == null
						continue

					@shops.push(shopData)

			@disableRoles = _.isEmpty(_.find(@roles, {id: @user.role_id}))
		else
			@user.entity_type = @BACKEND_USER_ENTITY_TYPE.USER
			@mainCrud.isNewEntity = true

			# Prefill shops on user object if not enterprise
			if @shopsList.length == 1 && !@ConfigurationService.isEnabled("Backoffice.ShopManagement.Shops.EnableSearch")
				@shops = @shopsList

		@showQrCodeGeneration = @shouldShowQrCodeGeneration()

	save: ->
		@mainCrud.saving = true

		user = @CopyService.copy(@user, 'image')
		user.shops = _.pluck(@shops, 'id')

		delete user.merchant_group
		delete user.has_password

		@UserRepository
			.saveWithAttachment user, @mainCrud.isNewEntity
			.then (response) =>
				if !@mainCrud.isNewEntity && @currentUser?.id == user.id && user.password
					# Current user is editing it's own password
					@UserService.reLogin(user.password)

				@user.image = response.data.image
				@user.has_password = response.data.has_password
				@hasPassword = @user.has_password

				@mainCrud.entityTitle = response.data.full_name

				@afterSave(response, undefined, undefined, 'full_name')
					.then =>
						@showQrCodeGeneration = @shouldShowQrCodeGeneration()
			.catch (response) =>
				@handleErrors response, 'general.user'

	delete: ->
		@deleteEntity @UserRepository, @user, undefined, undefined, 'full_name'

	findShops: (searchString) ->
		query = @ShopRepository.getQuery()
		query.criteria 'name', 'LIKE', searchString

		return @ShopRepository.findByQuery query

	isEmailRequired: ->
		return @user.entity_type == @types.employees || @hasPassword || !_.isEmpty(@user.password)

	resolveQrCodeUrl: (userId) ->
		@AuthenticationRepository
			.generateQrCode(userId)
			.then (qrCode) =>
				@$sce.trustAsResourceUrl(URL.createObjectURL(qrCode))

	disposeQrCodeUrl: (url) ->
		URL.revokeObjectURL(url.rawUrl)

	shouldShowQrCodeGeneration: ->
		if !@isLoginQrCodeGenerationEnabled
			return false

		return !@mainCrud.isNewEntity && @user.has_password && @user.email != null && (@currentUser == null || @currentUser.id == @user.id)
